import { gql, TypedDocumentNode } from '@apollo/client'
import { committeeFragment } from './CommitteeFragment'
import { functionCodeFragment } from './FunctionCodeFragment'
import type { ContractDatumFragment } from './__generated__/ContractDatumFragment'

export const contractDatumFragment: TypedDocumentNode<ContractDatumFragment> = gql`
  ${committeeFragment}
  ${functionCodeFragment}

  fragment ContractDatumFragment on ContractDatum {
    committee {
      ...CommitteeFragment
    }
    functionCode {
      ...FunctionCodeFragment
    }
    id
    isFlexi
    noVatApplicable
    vivaldisOffice
  }
`
